import { SubmittedAnswer } from "../../API";
import { AnswerOption } from "./assessmentEventsAPI";

export const answersToSubmittedPayload = (
  answers: AnswerOption[]
): SubmittedAnswer[] =>
  answers
    .map((answer) => {
      if (
        answer.questionId &&
        answer.value !== undefined &&
        answer.value !== null
      ) {
        return { questionId: answer.questionId, value: answer.value };
      }
      return null;
    })
    .flatMap((row) => (row ? [row] : []));
